import { InjectionToken } from '@angular/core';
import { CoralogixConfig } from '../types';

export const CORALOGIX_CONFIG = new InjectionToken<CoralogixConfig>('Coralogix configuration');
